<template>
    <li>
        <b-input-group>
            <b-input v-model="query" placeholder="Search..." @keyup.enter="action"/>
            <b-input-group-append>
                <b-button variant="primary" class="mh-btn" @click="action"><i class="far fa-search"></i></b-button>
            </b-input-group-append>
        </b-input-group>
    </li>
</template>

<script>
    export default {
        name: 'SearchListItem',
        data: function() {
            return {
                query: ''
            }
        },
        methods: {
            action: function() {
                this.$emit('action', this.query);
                this.query = '';
            }
        }
    }
</script>

<style lang="scss" scoped>

    $color: #fafafa;

    li {
        background-color: $color !important;
        color: white;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: bold;
        padding: 15px 15px 15px 10px !important;
        border-bottom: 1px solid $color !important;

        cursor: auto !important;

        .title {
            font-size: 15px;
            font-weight: bold;
        }

        &:hover {
            background-color: $color !important;
        }

        .mh-btn {
            background-color: lighten(#28547F, 10);
            border: lighten(#28547F, 10);

            &:hover {
                background-color: #28547F;
            }
        }
    }
</style>
